import api from '../axios/api';
import { hyperflowCredentialsLoaded, hyperflowAccessChanged } from '../store/actions/hyperflow'
import store from '../store/store';

const HYPERFLOW_CONFIG = {
  // Token do canal WebSDK configurado no painel do Hyperflow
  CHANNEL_TOKEN: 'd00ad658d2abc66b8a9235bc2205648a',

  // URL do script do Hyperflow
  SCRIPT_URL: 'https://webchat.hyperflow.global/sdk.js',

  // Endpoint para obter o JWT assinado (backend GEC)
  ME_ENDPOINT: '/hyperflow/me',

  // Configurações de debug
  DEBUG: true
};


class HyperflowService {
  private isScriptLoaded = false
  private isInitialized = false

  // Carrega o script do Hyperflow
  loadScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.isScriptLoaded) {
        resolve()
        return
      }

      const existingScript = document.querySelector(
        `script[src="${HYPERFLOW_CONFIG.SCRIPT_URL}"]`
      )

      if (existingScript) {
        this.isScriptLoaded = true
        resolve()
        return
      }

      const script = document.createElement('script')
      script.src = HYPERFLOW_CONFIG.SCRIPT_URL
      script.async = true

      script.onload = () => {
        this.isScriptLoaded = true
        resolve()
      }

      script.onerror = () => {
        reject(new Error('Falha ao carregar o script Hyperflow'))
      }

      document.body.appendChild(script)
    })
  }

  // Verifica se as credenciais estão disponíveis
  private checkCredentials(): { token: string; selectedTenant: string; access: string } | null {
    const token = localStorage.getItem('token')
    const selectedTenant = localStorage.getItem('selectedTenant')
    const access = localStorage.getItem('access')

    if (!token || !selectedTenant || !access) {
      return null
    }

    return { token, selectedTenant, access }
  }

  // Obtém credenciais do Hyperflow
  async getCredentials(): Promise<string | null> {
    const credentials = this.checkCredentials()
    if (!credentials) {
      throw new Error('Credenciais necessárias não encontradas no localStorage')
    }

    const state = store.getState()
    const { credentialsLoaded, lastAccessCheck } = state.hyperflow

    // Verifica se o access mudou
    if (state.hyperflow.currentAccess !== credentials.access) {
      store.dispatch(hyperflowAccessChanged(credentials.access))
    }

    // Se já carregou e o access não mudou, não faz a chamada
    if (credentialsLoaded && lastAccessCheck === credentials.access) {
      console.log('Credenciais do Hyperflow já carregadas')
      return null
    }

    try {
      const response = await api.post(HYPERFLOW_CONFIG.ME_ENDPOINT)

      if (!response.data || response.data.err) {
        throw new Error('Falha ao obter credenciais do Hyperflow')
      }

      // Marca como carregado no Redux
      store.dispatch(hyperflowCredentialsLoaded(credentials.access))

      return response.data.signedObject
    } catch (error) {
      console.error('Erro ao obter credenciais do Hyperflow:', error)
      throw error
    }
  }

  // Inicializa o Hyperflow
  async initializeWithUser(): Promise<void> {
    try {
      await this.loadScript()

      const signedObject = await this.getCredentials()
      if (!signedObject) {
        console.log('Hyperflow já inicializado')
        return
      }


      console.log('initializeWithUser')

      const hyperflow = (window as any).Hyperflow
      hyperflow.reinit(HYPERFLOW_CONFIG.CHANNEL_TOKEN, {
        sender: signedObject
      })

      this.isInitialized = true
      console.log('Hyperflow inicializado com sucesso')
    } catch (error) {
      console.error('Erro ao inicializar Hyperflow:', error)
      throw error
    }
  }

  async initializeNoUser(): Promise<void> {
    try {
      await this.loadScript()
      if (!(window as any).Hyperflow) {
        throw new Error('Script do Hyperflow não carregado')
      }

      console.log('initializeNoUser')

      const hyperflow = (window as any).Hyperflow
      hyperflow.reinit(HYPERFLOW_CONFIG.CHANNEL_TOKEN)
      this.isInitialized = true
    } catch (error) {
      console.error('Erro ao inicializar Hyperflow:', error)
      throw error
    }
  }

  // Verifica se está inicializado
  isReady(): boolean {
    return this.isScriptLoaded && this.isInitialized
  }

}

export default new HyperflowService()
